import BuildingCard from './BuildingCard';

export default BuildingCard;



// WEBPACK FOOTER //
// ./src/components/BuildingCard/index.js